import { ContentNugget } from '@backrs_ui/common-ui';

import {
  fetchOneContentNuggetBySlug,
  searchForContentScholarship,
  searchForCareerPathById,
  searchForProfileInternalById,
  searchForContentInternship,
  searchForPostById,
  searchForContentProfileExternalById,
  searchForGeneratedContentByUuid,
} from '@backrs_ui/grow-ui/src/redux/contentNugget/thunks/oneNuggetBySlug';
import { AppDispatch } from '@backrs_ui/grow-ui/src/redux/store';

import { PostHog } from 'posthog-js';

const handleFetchOneContentNuggetBySlug = async (dispatch: AppDispatch, slug: string) => {
  try {
    await dispatch(fetchOneContentNuggetBySlug({ slug }));
  } catch (error) {
    console.error('Failed to fetch content nugget:', error);
  }
};

const handleFetchOneScholarshipById = async (dispatch: AppDispatch, id: string) => {
  try {
    await dispatch(searchForContentScholarship({ search_term: id }));
  } catch (error) {
    console.error('Failed to fetch scholarship:', error);
  }
};

const handleFetchOneInternshipById = async (dispatch: AppDispatch, id: string) => {
  try {
    await dispatch(searchForContentInternship({ search_term: id }));
  } catch (error) {
    console.error('Failed to fetch internship:', error);
  }
};

const handleFetchOneCareerPathById = async (dispatch: AppDispatch, id: string) => {
  try {
    await dispatch(searchForCareerPathById({ id }));
  } catch (error) {
    console.error('Failed to fetch career path:', error);
  }
};

const handleFetchOneProfileInternalById = async (dispatch: AppDispatch, id: string) => {
  try {
    await dispatch(searchForProfileInternalById({ id }));
  } catch (error) {
    console.error('Failed to fetch profile internal:', error);
  }
};

const handleFetchOneProfileExternalById = async (dispatch: AppDispatch, id: string) => {
  try {
    await dispatch(searchForContentProfileExternalById({ search_term: id }));
  } catch (error) {
    console.error('Failed to fetch profile external:', error);
  }
};

const handleFetchOnePostById = async (dispatch: AppDispatch, id: string) => {
  try {
    await dispatch(searchForPostById({ id }));
  } catch (error) {
    console.error('Failed to fetch profile internal:', error);
  }
};

const handleFetchOneGeneratedContentByUuid = async (dispatch: AppDispatch, uuid: string) => {
  try {
    await dispatch(searchForGeneratedContentByUuid({ uuid }));
  } catch (error) {
    console.error('Failed to fetch generated content:', error);
  }
};

type HandlePostHogOpenedSharedNuggetProps = Readonly<{
  postHog: PostHog;
  dispatch: AppDispatch;
  preLinkedNuggetSlug: string | null;
  preLinkedScholarshipId: string | null;
  preLinkedCareerPathId: string | null;
  preLinkedProfileInternalId: string | null;
  preLinkedProfileExternalId: string | null;
  preLinkedInternshipId: string | null;
  preLinkedPostId: string | null;
  preLinkedGeneratedContentId: string | null;
  fetchedPreLinkedNugget?: ContentNugget;
}>;

export const handlePostHogOpenedSharedNugget = async ({
  postHog,
  dispatch,
  preLinkedNuggetSlug,
  preLinkedScholarshipId,
  preLinkedCareerPathId,
  preLinkedProfileInternalId,
  preLinkedProfileExternalId,
  preLinkedInternshipId,
  preLinkedPostId,
  preLinkedGeneratedContentId,
  fetchedPreLinkedNugget,
}: HandlePostHogOpenedSharedNuggetProps) => {
  if (preLinkedNuggetSlug) {
    handleFetchOneContentNuggetBySlug(dispatch, preLinkedNuggetSlug);
    postHog.capture('viewed_shared_nugget', {
      slug: preLinkedNuggetSlug,
      id: fetchedPreLinkedNugget?.id,
      type: 'nugget',
    });
  }

  if (preLinkedScholarshipId) {
    handleFetchOneScholarshipById(dispatch, preLinkedScholarshipId);
    postHog.capture('viewed_shared_nugget', {
      id: preLinkedScholarshipId,
      type: 'scholarship',
    });
  }

  if (preLinkedInternshipId) {
    handleFetchOneInternshipById(dispatch, preLinkedInternshipId);
    postHog.capture('viewed_shared_nugget', {
      id: preLinkedInternshipId,
      type: 'internship',
    });
  }

  if (preLinkedCareerPathId) {
    handleFetchOneCareerPathById(dispatch, preLinkedCareerPathId);
    postHog.capture('viewed_shared_nugget', {
      id: preLinkedCareerPathId,
      type: 'career-path',
    });
  }

  if (preLinkedProfileInternalId) {
    handleFetchOneProfileInternalById(dispatch, preLinkedProfileInternalId);
    postHog.capture('viewed_shared_nugget', {
      id: preLinkedProfileInternalId,
      type: 'profile-internal',
    });
  }

  if (preLinkedProfileExternalId) {
    handleFetchOneProfileExternalById(dispatch, preLinkedProfileExternalId);
    postHog.capture('viewed_shared_nugget', {
      id: preLinkedProfileExternalId,
      type: 'profile-external',
    });
  }

  if (preLinkedPostId) {
    handleFetchOnePostById(dispatch, preLinkedPostId);
    postHog.capture('viewed_shared_nugget', {
      id: preLinkedPostId,
      type: 'post',
    });
  }

  if (preLinkedGeneratedContentId) {
    handleFetchOneGeneratedContentByUuid(dispatch, preLinkedGeneratedContentId);
    postHog.capture('viewed_shared_nugget', {
      id: preLinkedGeneratedContentId,
      type: 'generated-content',
    });
  }
};
